import { ValidationErrors, ValidatorFn } from '@angular/forms';

export function selfSetLimit(value: boolean): ValidatorFn {
    return (): ValidationErrors | null => {
        return { selfSetLimit: value };
    };
}
